// extracted by mini-css-extract-plugin
module.exports = {"body":"Result_body__1GOLK","headtext":"Result_headtext__3ZaCi"};